// extracted by mini-css-extract-plugin
export var btn = "flowStepBusinessDetails-module--btn--d1b84";
export var inner = "flowStepBusinessDetails-module--inner--ce6bd";